const setItem = (key, value) => localStorage.setItem(key, value);

const getItem = (key, type = 'none') => {
  if (type === 'json') {
    const value = localStorage.getItem(key);
    if (value) return JSON.parse(value);
    return null;
  }
  return localStorage.getItem(key);
};

const removeItem = (key) => localStorage.removeItem(key);

export { getItem, removeItem, setItem };
